import { render, staticRenderFns } from "./SystemCustomNotificationsStep.vue?vue&type=template&id=0bddad06"
import script from "./SystemCustomNotificationsStep.vue?vue&type=script&lang=js"
export * from "./SystemCustomNotificationsStep.vue?vue&type=script&lang=js"
import style0 from "./SystemCustomNotificationsStep.vue?vue&type=style&index=0&id=0bddad06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports